/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_UsernameInputs */

const en_user_username = /** @type {(inputs: User_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

const ja_user_username = /** @type {(inputs: User_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名`)
};

const fr_user_username = /** @type {(inputs: User_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d'utilisateur`)
};

const de_user_username = /** @type {(inputs: User_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {User_UsernameInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_username = /** @type {((inputs?: User_UsernameInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_UsernameInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_username(inputs)
	if (locale === "ja") return ja_user_username(inputs)
	if (locale === "fr") return fr_user_username(inputs)
	return de_user_username(inputs)
});